/* eslint-disable react/jsx-no-bind */
//@flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Loader } from '@locus-taxy/neo-ui';
import { APIErrorScreen } from 'common/components/core/errors/APIErrorScreen';
import { ApiStatusEnum } from 'common/enums/API';
import useGetProvider from './useGetProvider';
import { ProviderContext } from './ProviderContext';
import { extractAssets } from './utils';

type Props = {
    providerId: ?string,
    children: React.Node
};

export const ProviderDataFetcher = ({
    providerId,
    children
}: Props): React.Node => {
    const { t } = useTranslation();
    const providerQuery = useGetProvider(providerId);

    if (providerQuery.status === ApiStatusEnum.Loading) {
        return (
            <Loader height="100%" width="100%" size="large" color="blue.500" />
        );
    }
    if (providerQuery.status === ApiStatusEnum.Error) {
        return (
            <APIErrorScreen
                actionLabel={t('retry')}
                onActionClick={() => providerQuery.refetch()}
                subtitle={t('genericDataFetchError')}
            />
        );
    }

    const provider = providerQuery.data;
    const assets = extractAssets(provider);
    return (
        <ProviderContext.Provider
            value={{ assets, providerName: provider?.name }}
        >
            {children}
        </ProviderContext.Provider>
    );
};
